import './App.css';

function App() {
  return (
    <div className="dashboard-container">
      <div className="dashboard-responsive">
        <iframe
          title="Dashboard Hotel Plaza"
          src="https://lookerstudio.google.com/embed/reporting/90143b4c-01b5-4702-8d17-ac03ec756b37/page/p_sa7il0tdtd"
          frameBorder="0"
          allowFullScreen
          sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        ></iframe>
      </div>
    </div>
  );
}

export default App;